import { SUPPORTED_NETWORKS } from '../../configs/Connect/Configs.networks';
import { ChainId } from '../../configs/Connect/Configs.chainId';

export const networks = [SUPPORTED_NETWORKS[ChainId.MAINNET], SUPPORTED_NETWORKS[ChainId.BSC]];

export const ACTION_TYPES = {
    CHOOSE_NETWORK: '[connect] action choose network',
};
